<div class="feature-label-maker-container">
  <div class="feature-label-maker">
    <div class="header">
      <h2>Label Maker</h2>
      <p>Design and customize label templates for your store</p>
    </div>

    <div class="label-designer-container">
      <app-label-designer
        [setSelectedStore]="selectedStore()"
        (printRequest)="onPrintRequest($event)">
      </app-label-designer>
    </div>

    <app-label-printer
      [design]="labelDesign"
      [data]="labelData">
    </app-label-printer>
  </div>
</div>
